export const CHANGE_ADDITIO_STUDENT = 'change-additio-student'
export const CHANGE_PAGINATION_PAGE = 'change-pagination-page'
export const CLEAN_EVALUATION_FILTERS = 'clean-evaluation-filters'
export const CLOSE_ADDITIO_ACTIVITY_MODAL = 'close-additio-activity-modal'
export const PATCH_SYNC_ACTIVITES = 'patch-sync-activities'
export const SAVE_DRAFT = 'save-draft'
export const SAVE_GRADE = 'save-grade'
export const SYNC_ACTIVITES = 'sync-activities'

export const TRACK_EVENTS_ELEMENT_TYPES = {
  BOOKS: 'BOOKS',
  CATALOGUE: 'CATALOGUE',
  CLASSROOMS: 'CLASSROOMS',
  EVALUATIONS: 'EVALUATIONS',
  HOME: 'HOME',
  PROFILE: 'PROFILE',
}
